import { TypedDocumentNode, gql } from '@apollo/client';
import { UnseenNotificationDto, UserDto } from '../helpers/dtos';

export const GET_LOGGED_USER = gql`
  query LoggedUser {
    loggedUser {
      id
      name
      role
      avatar
      email
      phone
      forcePasswordChange
      supportHash
      lastCredentialType
      stations
      preferedLanguage
    }
  }
`;

export const GET_COMPANY = gql`
  query GetCompany {
    company {
      id
      name
      appUrl
      timezone
    }
  }
`;

export const GET_MENU_STATIONS = gql`
  query GetStations($params: StationsParams!) {
    stations(params: $params) {
      stations {
        id
        name
      }
    }
  }
`;

export const VALIDATE_TOKEN: TypedDocumentNode<
  { validateToken: UserDto },
  { token: string | null }
> = gql`
  query ValidateToken($token: String!) {
    validateToken(token: $token) {
      id
      name
      email
    }
  }
`;

export const VALIDATE_APP_TOKEN: TypedDocumentNode<
  { validateAppToken: UserDto },
  { token: string | null; tokenContext?: string }
> = gql`
  query ValidateAppToken($token: String!, $tokenContext: String) {
    validateAppToken(token: $token, tokenContext: $tokenContext) {
      avatar
      email
      forcePasswordChange
      id
      lastCredentialType
      name
      phone
      role
      stations
      supportHash
      permissions {
        subject
        actions
      }
    }
  }
`;

export const GET_UNSEEN_NOTIFICATIONS: TypedDocumentNode<
  UnseenNotificationDto,
  { skipAlerts: boolean }
> = gql`
  query GetUnseenReports($skipAlerts: Boolean!) {
    unseenReports {
      totalItems
    }
    unseenAlerts @skip(if: $skipAlerts) {
      totalItems
    }
  }
`;
